<template>
  <div class="bill-template-view page--bill-template-view">
    <div class="page__header">
      <div class="page__title">
        <router-link :to="backLinkRoute" class="page__back-link">
          <arrow-button
            class="page__back-link-icon"
            :rotated180="true"
          ></arrow-button>
        </router-link>
        <div class="page__title-text">
          {{ template.TemplateName }}
        </div>
      </div>
    </div>
    <div class="bill">
      <div class="bill__header"></div>
      <bill-template-details
        :template="template"
        @linkCopied="handleLinkCopied"
      ></bill-template-details>
      <div class="bill__actions">
        <primary-button
          v-if="detailsActions.mainAction"
          class="bill__actions-item"
          :label="detailsActions.mainAction.label"
          @click="detailsActions.mainAction.handler"
        ></primary-button>
        <no-bg-button
          v-if="detailsActions.secondaryAction"
          class="bill__actions-item"
          :icon="detailsActions.secondaryAction.icon"
          :label="detailsActions.secondaryAction.label"
          @click="detailsActions.secondaryAction.handler"
        ></no-bg-button>
      </div>
    </div>
    <share-bill-template-link-popup
      :template="template"
      ref="shareBillTemplateLinkPopup"
    ></share-bill-template-link-popup>
    <success-notification
      ref="billTemplateLinkCopiedNotification"
      :text="$t('bills.popup.share-bill-link.notifications.copied')"
    ></success-notification>
  </div>
</template>

<script>
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import moment from 'moment'
import BillCreatedDetails from '@vue-app/components/company/bills/details/BillCreatedDetails.vue'
import BillPaidDetails from '@vue-app/components/company/bills/details/BillPaidDetails.vue'
import BillCanceledDetails from '@vue-app/components/company/bills/details/BillCanceledDetails.vue'
import BillRefundDetails from '@vue-app/components/company/bills/details/BillRefundDetails.vue'
import ShareBillLinkPopup from '@vue-app/components/company/bills/popup/ShareBillLinkPopup.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import { Bill } from '@js-app/entities/Bill'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import BillTemplateDetails from '@vue-app/components/company/bills/details/BillTemplateDetails.vue'
import ShareBillTemplateLinkPopup from '@vue-app/components/company/bills/popup/ShareBillTemplateLinkPopup.vue'

export default {
  name: 'BillTemplateView',
  components: {
    ShareBillTemplateLinkPopup,
    BillTemplateDetails,
    ArrowButton,
    SuccessNotification,
    ShareBillLinkPopup,
    NoBgButton,
    PrimaryButton,
    TransactionStatus,
    BillCreatedDetails,
    BillPaidDetails,
    BillCanceledDetails,
    BillRefundDetails,
  },
  props: ['id', 'templateId'],
  data() {
    return {
      template: {},
    }
  },
  created() {
    this.loadTemplate()
  },
  methods: {
    async loadTemplate() {
      let _templateResponse = await CompaniesApi.getBillTemplate(
        this.id,
        this.templateId
      )
      this.template = _templateResponse.data.BillTemplate
    },

    toBillsTemplatesPage() {
      this.$router.push(
        RouteHelper.getRoute('bills-templates', { companyId: this.id })
      )
    },

    shareBill() {
      this.$refs.shareBillTemplateLinkPopup.open()
    },

    handleLinkCopied() {
      this.$refs.billTemplateLinkCopiedNotification.show()
    },
  },
  computed: {
    backLinkRoute() {
      return RouteHelper.getRoute('bills-templates', { companyId: this.id })
    },

    detailsActions() {
      return {
        mainAction: {
          label: this.$t('bill-template-view.bill.share'),
          handler: this.shareBill,
        },
        secondaryAction: {
          label: this.$t('bill-template-view.bill.back-to-history'),
          handler: this.toBillsTemplatesPage,
          icon: null,
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--bill-template-view {
    padding-top: 31px;
  }
}
.bill {
  width: 100%;
  max-width: 615px;
  margin-top: 27px;
  background: #ffffff;
  border-radius: 22px;
  padding: 29px 27px 38px;
  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  &__number {
    margin-left: 27px;
    margin-right: 27px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #666d79;
  }

  &__lang {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #585f6d;
    margin-left: auto;
    margin-right: 30px;
  }

  &__status {
    width: 85px;
  }

  &__info {
    margin-top: 25px;
  }

  &__actions {
    margin-top: 43px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-item {
      width: 100%;
      max-width: 290px;
      padding: 25px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
